/* eslint-disable @typescript-eslint/no-explicit-any */
// src/slices/DataRTK.ts
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchData = createAsyncThunk(
  "data/fetchData",
  async (url, { rejectWithValue }) => {
    try {
      const response = await fetch(url as any);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      return data;
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  }
);
const initState: any = {
  items: null,
  loading: false,
  error: null,
};
const dataSlice = createSlice({
  name: "data",
  initialState: initState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const dataReducer = dataSlice.reducer;
export const selectData = (state: any) => state.data;
